<template>
  <div>    
    <v-card
      flat
      class="px-2 mt-3 mx-1"
    > 
      <v-row 
        class="mx-1"
      >
        <v-col
          cols="12"
          sm="6"
        >
          <v-btn-toggle
            v-if="firstTab.userReward!==undefined"
            v-model="selectType"
            class="d-flex"
            borderless
            multiple
            dense
            color="green"
          >
            <v-btn
              :value="1"
              depressed
              width="100%"
              @click="changeStatus(firstTab.number_type.id,firstTab.number_type.name)"
            >
              <v-icon>mdi-check</v-icon><h5>{{ firstTab.number_type.name }} ({{ firstTab.userReward | currency }})</h5>
            </v-btn>
          </v-btn-toggle>
        </v-col> 
        <v-col
          cols="12"
          sm="6" 
        >
          <v-btn-toggle
            v-if="secondTab.userReward!==undefined"
            v-model="selectType"
            multiple
            class="d-flex"
            borderless
            dense
            color="green"
          >
            <v-btn
              :value="2"
              depressed
              width="100%"
              @click="changeStatus(secondTab.number_type.id,secondTab.number_type.name)"
            >
              <v-icon>mdi-check</v-icon><h5>{{ secondTab.number_type.name }} ({{ secondTab.userReward | currency }})</h5>
            </v-btn>
          </v-btn-toggle>
        </v-col> 
        <v-col
          class="d-flex justify-center px-2"
          cols="12" 
        >  
          <v-btn-toggle
            v-model="toggleSelected" 
            color="orange"
            class="d-block "
            style="width : 100% !important"
            mandatory
            borderless 
          >  
            <v-btn  
              v-for="(item,i) in 10"
              :key="i"  
              width="17%" 
              class="notranslate force-round  ma-1" 
            > 
              {{ i+'00' }} 
            </v-btn> 
          </v-btn-toggle>   
        </v-col>
      </v-row>
    </v-card>
    <div 
      :class="!(firstTab.status||(!secondTab.Is_empty&&secondTab.status)) ? 'diable-all' :''"
    >
      <v-row
        no-gutters 
      >
        <v-col
          class="px-1 mt-3"
          cols="12"
          md="7"
        > 
          <v-row no-gutters>
            <v-card
              flat  
              width="100%"
              class="pa-3 d-flex justify-center" 
            >
              <v-row 
                no-gutters 
                class="mx-1"
              > 
                <v-col 
                  v-for="(item,i) in selectAmountList"
                  :key="i"  
                  class="column-five"
                >
                  <v-btn-toggle
                    v-model="selectAmount" 
                    color="var(--bg-secondary-color)" 
                    class="d-block ma-1"
                    multiple 
                    borderless
                  >
                    <v-btn 
                      class="notranslate  force-round"
                      block
                      :value="item.value" 
                      :color="checkLimitCondition(item)"
                      :disabled="checkDisable(item)"
                      @click="addValue(item)"
                    >
                      {{ checkDisable(item) ? $t('button.out-of-stock') : item.number }} 
                    </v-btn> 
                  </v-btn-toggle>
                </v-col>
              </v-row>
            </v-card> 
          </v-row>
          <v-row no-gutters>
            <limitlistcard 
              :first-tab="firstTab" 
              :first-tab-status="firstTab.status" 
              :second-tab="secondTab" 
              :second-tab-status="secondTab.status" 
            /> 
          </v-row>
        </v-col>
        <v-col 
          class="px-1 mt-3"
          cols="12"
          md="5"
        >
          <v-card
            flat
            class="text-center py-3"
          >
            <h4>{{ $t('enter-number') }}</h4>
            <v-row
              no-gutters
              class="mx-3"
            >
              <v-col class="px-1">
                <n-number-field-specific
                  v-model="digitNumber1" 
                  readonly 
                />
              </v-col>
              <v-col class="px-1">
                <n-number-field-specific
                  v-model="digitNumber2"   
                  readonly 
                />
              </v-col>
              <v-col class="px-1">
                <n-number-field-specific
                  v-model="digitNumber3" 
                  readonly 
                />
              </v-col>
            </v-row>
            <numPad
              :is-disable="!(firstTab.status||(!secondTab['Is_empty']&&secondTab.status))"
              :method-digit="addDigit"
              @removeLastNumber="removeLastNumber"
              @clearAll="clearAll"
              @removeDigit="removeDigit"
            />
          </v-card> 
          <slot />
        </v-col>
      </v-row>
    </div>
  </div>
</template>
<script>
import numPad from './NumPad'
import limitlistcard from './LimitList'
import * as c from '@/const/setTimeOutConfig'
import { findPermutations } from '@/plugins/helper'

export default {
  components:{
    numPad, 
    limitlistcard
  },
  props : {
    switchToggle : {
      type:Boolean,
      default:false
    },
    indexSelect : { 
      type:Number,
      default:0
    },
    firstTab : {
      type:[Object,Boolean],
      default:()=>{
        return {
          limit_conditions : []
          }
      }
    },
    secondTab: {
      type:[Object,Boolean],
      default:false
    },
    userSelect:{
      type:Array,
      default:()=>{
        return[]
      }
    },
    filterNumber:{
      type:String,
      default:()=>''
    },     
    voucher:{
      type:Object,
      default:()=>{}
    },
  },   
  data (){
    return { 
      selectAmount:[],
      selectType : [], 
      toggleSelected:0,
      digitNumber1:'',
      digitNumber2:'',
      digitNumber3:'',  
      selectAmountBase:[],
      LIMITL : 2, 
      ALMOST : 1, 
      NORMAL : 0
    }
  },  
  computed : {
    selectAmountList () { 
      let array = this.filterNumber ? 
                  this.selectAmountBase
                  .filter(x=>x.number
                  .includes(parseInt(this.filterNumber))) :
                  this.selectAmountBase.slice(this.toggleSelected*100,this.toggleSelected*100+100)  
      return array 
    }
  },
  watch:{   
    indexSelect () { 
      this.initLimitCondition()
      this.checkStatusActive()
    },
    toggleSelected () { 
      this.checkStatusActive()
    },

    userSelect () {
      this.checkStatusActive()
    },
    digitNumber3 (){
      let value = this.digitNumber1.toString()+this.digitNumber2.toString()+this.digitNumber3.toString()
      let item = this.selectAmountBase.find(x=>x.number===value)
      if(item && !this.selectAmount.includes(item.value)&&this.digitNumber3.length!==0){
        setTimeout(()=>{
          this.addValue(item)
          this.selectAmount.push(item.value)
          this.digitNumber1=''
          this.digitNumber2=''
          this.digitNumber3=''
        ,c.COUNTDOWNONESEC})
      }
      else if(item && this.digitNumber3.length!==0){
        this.$noty.error(this.$t('already-select-number',{number:item.value}))    
        this.digitNumber1=''
        this.digitNumber2=''
        this.digitNumber3=''
      }
    },  
  },
  async created () { 
    this.checkStatusActive()
    this.initLimitCondition()
  },
  methods :{
    initLimitCondition () {    
      this.selectAmountBase = Array.from(Array(1000).keys()).map(x=>{
        let result = {
          value : x,
          number : this.changeNumbertoString(x),
          first : this.NORMAL,
          second : this.NORMAL,
          userReward_first : 0,
          userReward_second : 0
        } 
        let firstLimitFind = (this.firstTab.limit_conditions || []).filter(x=>x.number===result.number) 
        let secondLimitFind = (this.secondTab.limit_conditions || []).filter(x=>x.number===result.number) 
        
        if(firstLimitFind && firstLimitFind.length !==0){   
          let reward = Math.min.apply(Math,firstLimitFind.map(x=>x.quota_reward))  
          result.first = reward===0 ? this.LIMITL : this.ALMOST
          result.userReward_first =  reward
        }
        if(secondLimitFind && secondLimitFind.length !==0){  
          let reward = Math.min.apply(Math,secondLimitFind.map(x=>x.quota_reward))  
          result.second = reward===0 ? this.LIMITL : this.ALMOST
          result.userReward_second = reward
        }
        
        return result
      })   
    }, 

    checkLimitCondition (item) { 
      let check = this.secondTab.status ? item.second : this.firstTab.status ? item.first : null
      if(this.secondTab.status && this.firstTab.status) {
        check = Math.max(item.first,item.second)
      }
      switch(check){
        case this.NORMAL:
          return ''
        case this.ALMOST:
          return 'red'
        case this.LIMITL:
          return 'red'
          
      }
      return '' 
    }, 

    changeStatus (id,name) { 
      this.$ga.event('Button', 'ToggleSelectType', 'ThreeDigitPage', name)
      this.$emit('changeStatus',id)
      this.checkStatusActive ()
    }, 
    
    checkDisable (item) {
      let check = this.secondTab.status ? item.second : this.firstTab.status ? item.first : null
      if(this.secondTab.status && this.firstTab.status) {
        check = Math.max(item.first,item.second)
      }
      return check === this.LIMITL ? true : false
    }, 

    checkStatusActive () {  
      this.resetBoardDisplay() 
      this.selectType = this.firstTab.status&&this.secondTab.status 
      ? [1,2] 
      : this.firstTab.status ? [1] 
      : this.secondTab.status ? [2] 
      : []
      this.userSelect.forEach(element => {
        if((element.number_type_id===this.firstTab.number_type.id && this.firstTab.status) ||
        (element.number_type_id===this.secondTab.number_type.id && this.secondTab.status)) {
          this.selectAmount.push(parseInt(element.number)) 
        }
      }); 
    },

    removeLastNumber (){  
      this.$emit('removeLastNumber')
    },

    resetBoardDisplay () {  
      this.selectAmount = []  
      this.selectType = []
    },

    clearAll (){ 
      this.$emit('clearAll') 
    },

    removeDigit (){
      if(this.digitNumber2.length===0){
        this.digitNumber1 = ''
      }else{
        this.digitNumber2=''
      }
    },

    addDigit (number){
      if(this.digitNumber1.length===0){
          this.digitNumber1 = number
      }
      else if(this.digitNumber2.length===0){
          this.digitNumber2 = number
      }
      else{
          this.digitNumber3 = number
      }
    }, 

    changeNumbertoString (value){   
      return value<10 ? "00"+value.toString() : value<100 ? "0"+value.toString() :  value.toString()  
    },

    switchNumbertoString (value) {
      return findPermutations(this.changeNumbertoString(value))
      .filter(x=>!this.selectAmount.includes(parseInt(x)))
      .map(x=>this.selectAmountBase.find(y=>y.number===x)) 
    },

    async addValue (item){
      let changeNumbertoString = item.number
      
      // if(this.selectAmount.includes(item.value)) {  
      //   const result =  await this.$confirm('','คุณต้องการยกเลิกเลขนี้ใช่หรือไม่','warning') 
      //   if(!result){   
      //     return
      //   }
      // }   

      this.$ga.event('Button', 'Add&DeleteValue', 'ThreeDigitPage', changeNumbertoString) 
      let arrayResult = this.switchToggle&&!this.selectAmount.includes(item.value) 
      ? this.switchNumbertoString (item.value)
      :  [changeNumbertoString].map(x=>this.selectAmountBase.find(y=>y.number===x)) 
      this.loopAdd(arrayResult)
     
    },  

    loopAdd (array) { 
      let Bypass = false 
      let stakeMaxNumber = (this.voucher.rules || {}).stake_max_number
      let checkVoucherStake = this.voucher.rules && stakeMaxNumber

      array.forEach(e=>{
        let status = this.selectAmount.includes(e.value)
        let actionStatus = status ? 'delValue': 'addValue' 
  
        if( checkVoucherStake &&
            this.userSelect.length >= parseInt(stakeMaxNumber) &&
            actionStatus === 'addValue'
          ){ 
          if(!Bypass) {  
            this.$nextTick(()=>{
              this.checkStatusActive() 
            }) 
          }
          
          Bypass = true
          return
        } 

        if(this.firstTab.status && e.first !== this.LIMITL){ 
          let price = e.first === this.NORMAL ? this.firstTab.userReward : e.userReward_first
          this.$emit(actionStatus,price,e.number,this.firstTab.number_type.id,null,null,null)
        }
        if(this.secondTab.status && e.second !== this.LIMITL) {
          let price = e.second === this.NORMAL ? this.secondTab.userReward : e.userReward_second
          this.$emit(actionStatus,price,e.number,this.secondTab.number_type.id,null,null,null)
        }  
      }) 
    }
  }
}
</script> 
<style scoped>
@media only screen and (min-width: 1264) {
  .column-five {
    flex: 0 0 10% !important;
    max-width: 10% !important;
  }
}  
</style>